import { dataStar } from 'dls-icons-data'
import { createIcon } from '../common'

const IconStar = /*#__PURE__*/createIcon(dataStar)
export default IconStar
